/**
 * Notices handed to the designer route through navigation state, so a step
 * that changed the design (a duplicate whose production couldn't be updated)
 * can say so once the designer opens.
 */
type DesignerNoticesState = { designerNotices: string[] }

export const designerNoticesState = (
  notices: string[],
): DesignerNoticesState => ({
  designerNotices: notices,
})

export const readDesignerNotices = (state: unknown): string[] => {
  const notices = (state as Partial<DesignerNoticesState> | null)
    ?.designerNotices
  return Array.isArray(notices)
    ? notices.filter((notice): notice is string => typeof notice === `string`)
    : []
}
